// import React from "react";
// import { Container, Typography, Box } from "@mui/material";
// import "./About.css";

// const AboutUs = () => {
//     return (
        
//             <Container maxWidth="md" className="about-container">
//                 <Box className="about-box">
//                     <Typography variant="h4" className="about-title">About Us</Typography>
//                     <Typography variant="body1" className="about-text">
//                         Welcome to our platform, a comprehensive hub created on July 27, 2024,
//                         dedicated to enhancing digital experiences for everyone. At the heart
//                         of our mission lies the commitment to empower users with access to a
//                         wide range of applications, mirroring the global accessibility of
//                         platforms like the renowned app marketplaces, but with a unique focus
//                         on Indian users.
//                     </Typography>
//                     <Typography variant="body1" className="about-text">
//                         Our journey began with a simple yet powerful vision: to revolutionize
//                         the way people discover and download apps. We recognize the evolving
//                         needs of the digital age and strive to meet them by offering an
//                         extensive selection of applications. From utility and productivity
//                         apps to entertainment and lifestyle options, our platform is a
//                         one-stop destination for all your app needs.
//                     </Typography>
//                     <Typography variant="body1" className="about-text">
//                         We are not just about providing access to apps; we are about fostering
//                         a community where knowledge about the latest digital tools is shared
//                         and celebrated. Our platform is designed to be user-friendly,
//                         ensuring a seamless experience for everyone, from tech-savvy
//                         individuals to those just starting their digital journey.
//                     </Typography>
//                     <Typography variant="body1" className="about-text">
//                         Our focus on Indian applications sets us apart, reflecting our
//                         dedication to cater to the unique needs and preferences of our
//                         audience. We believe in the power of local solutions for local
//                         challenges, and our platform is a testament to this belief.
//                     </Typography>
//                     <Typography variant="body1" className="about-text">
//                         Join us in our endeavor to bring the best of digital innovations to
//                         your fingertips. Explore, download, and stay ahead in the
//                         ever-evolving world of apps with us.
//                     </Typography>
//                 </Box>
//             </Container>
//     );
// };

// export default AboutUs;
import React from "react";
import { Container, Typography, Box } from "@mui/material";
import "./About.css";

const AboutUs = () => {
    return (
        <Box className="about-page">
            <Container maxWidth="md" className="about-container">
                <Box className="about-box">
                    <Typography variant="h4" className="about-title">About Us</Typography>
                    <Typography variant="body1" className="about-text">
                        Welcome to our platform, a comprehensive hub created on July 27, 2024,
                        dedicated to enhancing digital experiences for everyone. At the heart
                        of our mission lies the commitment to empower users with access to a
                        wide range of applications, mirroring the global accessibility of
                        platforms like the renowned app marketplaces, but with a unique focus
                        on Indian users.
                    </Typography>
                    <Typography variant="body1" className="about-text">
                        Our journey began with a simple yet powerful vision: to revolutionize
                        the way people discover and download apps. We recognize the evolving
                        needs of the digital age and strive to meet them by offering an
                        extensive selection of applications. From utility and productivity
                        apps to entertainment and lifestyle options, our platform is a
                        one-stop destination for all your app needs.
                    </Typography>
                    <Typography variant="body1" className="about-text">
                        We are not just about providing access to apps; we are about fostering
                        a community where knowledge about the latest digital tools is shared
                        and celebrated. Our platform is designed to be user-friendly,
                        ensuring a seamless experience for everyone, from tech-savvy
                        individuals to those just starting their digital journey.
                    </Typography>
                    <Typography variant="body1" className="about-text">
                        Our focus on Indian applications sets us apart, reflecting our
                        dedication to cater to the unique needs and preferences of our
                        audience. We believe in the power of local solutions for local
                        challenges, and our platform is a testament to this belief.
                    </Typography>
                    <Typography variant="body1" className="about-text">
                        Join us in our endeavor to bring the best of digital innovations to
                        your fingertips. Explore, download, and stay ahead in the
                        ever-evolving world of apps with us.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default AboutUs;
